import { Info } from 'lucide-react'
import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

import { WorkerIcon } from '@/components/icons/worker'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { WorkerType } from '@/models/worker'

export interface WorkerTypeStampProps extends ComponentProps<'div'> {
  worker: WorkerType
}

export function WorkerTypeStamp({
  worker,
  className,
  ...props
}: WorkerTypeStampProps) {
  const notFoundWorker = worker !== 'gee' && worker !== '6be'

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={twMerge(
              'flex size-6 shrink-0 items-center justify-center rounded-full bg-blue-500 p-1',
              worker === 'gee' && 'bg-blue-500',
              worker === '6be' && 'bg-yellow-500',
              notFoundWorker && 'bg-gray-300',
              className,
            )}
            {...props}
          >
            {notFoundWorker ? (
              <Info className="text-monochromatic-500" />
            ) : (
              <WorkerIcon />
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          {notFoundWorker ? 'Desconhecido' : worker.toUpperCase()}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
